// extracted by mini-css-extract-plugin
module.exports = {"normalMax":"Index_normalMax__3PKec","normal":"Index_normal__2zney","normalh5":"Index_normalh5__3DGLl","animationFade":"Index_animationFade__2UBkv"};